import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import moment from 'moment';
import { ROOM_DEMO, ROOM_VDPC, ROOM_URGENT_CARE } from '../../env';
import { Box, Typography, Grid, TextField, MenuItem, Checkbox, Button, Autocomplete } from '@mui/material';
import { AiOutlineLeft } from "react-icons/ai";
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import useStyles from './mainStyles';
import ButtonComponent from '../../components/loaderNew';

const MedicalHistory = () => {
    let timeout = null;
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(state => state.patientReducer.loading);
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const providerData = useSelector(
        state => state.patientReducer.validateUser,
    );
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const { name, identifier, address } = patientDetails || {};
    const uuid = userData.user.person.uuid;
    const access_token = providerData && providerData.access_token;
    const childrenData = useSelector(state => state.patientReducer.selectedChildData);
    const roomStatus = useSelector(
        state => state.patientReducer.roomStatus,
    );
    const callID = useSelector(state => state.patientReducer.callID);
    const { user } = userData && userData;
    const { person } = user && user;
    const updateRoomStatusData = useSelector(
        state => state.patientReducer.updateRoomStatusData,
    );

    const medicationsData = useSelector(
        state => state.patientReducer.medicationsData,
    );
    const allergiesData = useSelector(
        state => state.patientReducer.allergiesData,
    );

    const [room, setRoomName] = useState('');

    useEffect(() => {
        if (Object.keys(roomStatus).length > 0) {
            if (roomStatus.status_code == 200) {
                console.log(
                    'User ready to call--------------------------------------------->',
                );
            } else if (roomStatus.status_code == 402) {
                // global.isAlertVisible = true;
                // Alert.alert(
                //     'Call ReConnect',
                //     'We noticed that you were not able to finish the last call. Do you want to resume?',
                //     [
                //         {
                //             text: 'YES',
                //             onPress: () => {
                //                 global.isAlertVisible = false;
                //                 dispatch(validClientActions.clearRoomStatus());
                //                 dispatch(
                //                     validClientActions.updateRoomStatus(
                //                         { patient_id: providerData.id, status: 'waiting' },
                //                         access_token,
                //                     ),
                //                 );
                //             },
                //         },
                //         {
                //             text: 'NO', //Nothing will happen
                //             onPress: () => {
                //                 global.isAlertVisible = false;
                //                 navigation.pop();
                //             },
                //         },
                //     ],
                // );
            }
        }
    }, [roomStatus]);

    useEffect(() => {
        let patientType = false;
        const { hintos_patient_id, hintos_member_status } = person && person;
        const type = identifier && identifier?.filter((s) => s?.system === 'urn:oid:fhir-portal')?.map(({ value }) => value).map((item) => {
            if (item === 'CCM' || item === 'RPM' || item === 'TCM') {
                patientType = true;
            }
        });
        if (patientType) {
            setRoomName(ROOM_DEMO);
        } else if (hintos_patient_id !== null && hintos_member_status === 'active') {
            setRoomName(ROOM_VDPC);
        } else {
            setRoomName(ROOM_VDPC);
        }
    }, []);

    useEffect(() => {
        (async () => {
            if (access_token && providerData && providerData.id) {
                let payload;
                if (childrenData && childrenData.child_id) {
                    payload = { patient_id: childrenData.child_id }
                } else {
                    payload = { patient_id: providerData.id }
                }
                dispatch(
                    patientActions.checkRoomStatus(
                        payload,
                        access_token,
                    ),
                );
            }
        })();
    }, [access_token, providerData]);
    useEffect(() => {
        (async () => {
            if (access_token && Object.keys(roomStatus).length > 0) {
                const params = {
                    patientId: childrenData && childrenData.child_id ? childrenData.child_id : providerData.id,
                    patientEmail: userData.user.email,
                    patientDob: userData.user.person.birth_date_at || '',
                    uuid: uuid,
                    staffid: 500,
                    call_started: moment(Date.now()).format('YYYY/MM/DD'),
                    room_name: ROOM_URGENT_CARE,//'vdpc',
                    call_type: 'connect',
                    device_type: window.navigator.userAgent,
                };
                dispatch(
                    patientActions.generateCallIdByPatientId(params, access_token),
                );
            }
        })();
    }, [access_token, roomStatus]);
    useEffect(() => {
        (async () => {
            if (Object.keys(updateRoomStatusData).length > 0) {
                if (updateRoomStatusData.status_code == 200) {
                    //navigation.navigate('callPreview', { generateCallId: true, roomName: room });
                }
            }
        })();
    }, [updateRoomStatusData]);
    useEffect(() => {
        (async () => {
            if (access_token && room !== '') {
                dispatch(
                    patientActions.getDocFromAlias(
                        {
                            alias: ROOM_URGENT_CARE//'vdpc' 
                        },
                        access_token,
                    ),
                );
            }
        })();
    }, [access_token, room]);


    const [isSelected, setSelection] = useState(false);
    const [isAllergy, setIsAllergy] = useState(false);
    const [medications, setMedications] = useState([]);
    const [allergies, setAllergies] = useState([]);
    const [type, setType] = useState('Medication');
    const [searchText, setSearchText] = useState('');
    const [medicationData, setMedicationsData] = useState([]);
    const [allergieData, setAllergiesData] = useState([]);

    const onNextSubmit = (e) => {
        e.preventDefault();
        if (medications && medications.length > 0) {
            dispatch(patientActions.storeMedication(medications));
        } else {
            dispatch(patientActions.storeMedication([]));
        }
        if (allergies && allergies.length > 0) {
            dispatch(patientActions.storeAllergy(allergies));
        } else {
            dispatch(patientActions.storeAllergy([]));
        }
        navigate('/room/medicalCondition');
    }

    useEffect(() => {
        let array = Object.values(allergiesData);
        if (array.length > 0 && array.includes('Allergy found!')) {
            var index = array.indexOf('Allergy found!');
            if (index > -1) {
                array.splice(index, 1);
            }
            let arr = [];
            array.map((item) => {
                arr.push(item.Name)
            });
            setAllergiesData(arr);
        } else setAllergiesData([]);
    }, [allergiesData]);

    useEffect(() => {
        setMedicationsData(medicationsData);
    }, [medicationsData]);
    const doSearch = async (search, type) => {
        setAllergiesData([]);
        setMedicationsData([]);
        //setModalData([])
        setSearchText(search);
        clearTimeout(timeout);
        if (search.trim().length > 2) {
            timeout = setTimeout(() => {
                //search function
                if (type === 'Medication') {
                    getMedicationList(search);
                } else if (type === 'Allergy') {
                    getAllergyList(search);
                }
            }, 2000);
        } else {
            setAllergiesData([]);
            setMedicationsData([]);
            //setModalData([]);
        }
    };

    const getMedicationList = searchText => {
        dispatch(patientActions.searchMedication(searchText, access_token));
    };

    const getAllergyList = searchText => {
        dispatch(patientActions.searchAllergy(searchText, access_token));
    };
    const onCheckMedication = () => {
        setMedicationsData([]);
        setSelection(!isSelected)
        setMedications([]);
        dispatch(patientActions.storeMedication([]));
    };
    const onCheckAllergy = () => {
        setAllergiesData([]);
        setIsAllergy(!isAllergy);
        setAllergies([]);
        dispatch(patientActions.storeAllergy([]));
    };
    return (
        <div style={{ padding: '10%' }}>
            <div style={{
                width: "100%",
                backgroundColor: "white",
                //height: "100%",
                display: "flex",
                flexDirection: "column",
            }}>
                <Typography className='topTitle'>Medical Information
                            <a href="" className="backArrow" onClick={(e) => { e.preventDefault(); navigate('/room/patient') }}>
                        <AiOutlineLeft />Back</a>
                </Typography>
            </div>
            <div style={{ marginTop: 20 }}>
                <Grid item >
                    <Grid container style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div className="PatientMedicalInfoText">
                            <p className="MedicalinfoText">What medications is the patient taking currently?</p>
                            <Autocomplete
                                multiple
                                fullWidth
                                id="ChooseMedication"
                                name="ChooseMedication"
                                onInputChange={(e, value) => { doSearch(value, 'Medication') }}
                                options={medicationData}
                                onChange={(e, value) => { setMedications(value) }}
                                disabled={isSelected}
                                filterSelectedOptions
                                loading={loading}
                                style={{
                                    fontFamily:'manrope'
                                }}
                                getOptionLabel={(option) => option}
                                // defaultValue={[MedicationsList[2]]}
                                renderInput={(loadMedications) => (
                                    <TextField
                                        {...loadMedications}
                                        variant="outlined"
                                        label="Select Medications"
                                        placeholder="Select Medications"
                                    />
                                )}
                            />
                        </div>
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div className="NoMedication">
                            <input type="checkbox" value="No Medication" onClick={onCheckMedication} name="no_medication" className="NoMedication" /> No Medication
                        </div>
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div className="PatientMedicalInfoText">
                            <p className="MedicalinfoText">What allergies does the patient have?</p>
                            <Autocomplete
                                multiple
                                id="ChooseAllergies"
                                name="ChooseAllergies"
                                options={allergieData}
                                disabled={isAllergy}
                                onChange={(e, value) => { setAllergies(value) }}
                                filterSelectedOptions
                                loading={loading}
                                getOptionLabel={(option) => option}
                                style={{
                                    fontFamily:'manrope'
                                }}
                                onInputChange={(e, value) => { doSearch(value, 'Allergy') }}
                                // defaultValue={[MedicationsList[2]]}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        fullWidth
                                        label="Select Allergies"
                                        placeholder="Select Allergies"
                                    />
                                )}
                            />
                        </div>
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div className="NoMedication">
                            <input type="checkbox" value="No Allergies" onClick={onCheckAllergy} name="NoAllergies" className="NoMedication" /> No Allergies
                        </div>
                    </Grid>
                </Grid>
                <div className={classes.PatientNextButton}>
                    <ButtonComponent onClick={(e) => { onNextSubmit(e) }}
                        loading={loading} title='Next'/>
                    {/* <Button
                        size="large"
                        variant="contained"
                        color='primary'
                        fullWidth
                        style={{ width: '100%', padding: '3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: 70, alignSelf: 'center' }}
                        //style={{ color: "#024C9C"  }}
                        //className={classes.createAccountButton}
                        onClick={(e) => { onNextSubmit(e) }}
                        disabled={loading}
                    >
                        Next
                        </Button> */}
                </div>
            </div>
        </div>
    )
}
// All medications list
const MedicationsList = [
    { title: 'Testamone', year: 1994 },
    { title: 'Tedizolid', year: 1972 },
    { title: 'Tedrigen', year: 1974 },
    { title: 'Teduglutide', year: 2008 },
];

// All Allergies list
const AllergiesList = [
    { title: 'Egg', year: 1994 },
    { title: 'Testim', year: 1972 },
    { title: 'Testopel Pellets', year: 1974 },
    { title: 'Testosterone', year: 2008 },
    { title: 'Testosterone Cypionate', year: 2008 },
    { title: 'Testosterone (Obsolete)', year: 2008 },
    { title: 'Tessalon (Obsolete)', year: 2008 },
];

export default MedicalHistory;
